//modules
import React from 'react';

//components
import { NavigationBar } from '../globalComponents/NavigationBar';
import { useTextAnimation } from '../globalComponents/UseTextAnimation';
import { RightsFooter } from '../globalComponents/RightsFooter';

//styles
import './ContactMe.css';

export const ContactMe = ({ className }) => {

    const emailIcon = './images/email_icon.svg';
    const emailLink = 'valentinagarciaaiello@gmail.com';  

    const behanceIcon = './images/behance_icon.svg';
    const behanceLink = 'https://www.behance.net/varrogan'; 

    const linkedinIcon = './images/linkedin_icon.svg';
    const linkedinLink = 'https://www.linkedin.com/in/valentina-garc%C3%ADa-aiello-403470204/'; 

    const { headingRef, subtitleRef, bodyRef } = useTextAnimation();

    return(
        <div className="page">  
            <NavigationBar />
            <div className="contact-page">
                <div className="left-container align-start">
                    <div className="contact-heading">
                        <h1 className="heading-1" ref={headingRef}>Let's work together.</h1>
                    </div>
                    <div>
                        <body className="subtitle hide-mobile" ref={(el) => (subtitleRef.current[0] = el)}> Feel free to reach out, I would love to hear about your project. </body>
                    </div>
                </div>
                <div className="right-container">
                    <h2 className="smiley-face brand" ref={(el) => (subtitleRef.current[1] = el)}> :) </h2>
                    <div className="social-line" ref={(el) => (bodyRef.current[0] = el)}>
                            <a href={emailLink} target="_blank" rel="noopener noreferrer" className="social-link" data-cursor="Go"> 
                                <body className="subtitle"> valentinagarciaaiello@gmail.com </body>
                                <img src={emailIcon} alt="" className="icon"/> 
                            </a>
                            <a href={linkedinLink} target="_blank" rel="noopener noreferrer" className="social-link" data-cursor="Go"> 
                                <body className="subtitle"> LinkedIn </body>
                                <img src={linkedinIcon} alt="" className="icon" /> 
                            </a>
                            <a href={behanceLink} target="_blank" rel="noopener noreferrer" className="social-link" data-cursor="Go"> 
                                <body className="subtitle"> Behance </body>
                                <img src={behanceIcon} alt="" className="icon"/> 
                            </a>
                    </div>
                </div>  
            </div>  
            <RightsFooter customClass= "footer-default-class" />
        </div>
    )
};